<template>
    <div class="record-report-container">
        <div class="t-top-bar">
            <div class="report-op">
                <el-input placeholder="员工编号、员工姓名" v-model="keyword" class="search-input"></el-input>
<!--                <el-cascader class="search-input" clearable v-model="searchDepart" placeholder="所属班组" :options="treeData"-->
<!--                             :props="{ expandTrigger: 'hover', label: 'name',value:'departmentId' }"></el-cascader>-->
              <el-select  class="search-input200" clearable v-model="selectColumn" placeholder="统计数据">
                <el-option v-for="(val,key, i) in reportColumn" :key="i" :label="val" :value="key"></el-option>
              </el-select>
              <el-cascader class="search-input200" clearable
                           v-model="searchDepart" placeholder="所属班组"  :options="treeData"
                           :props="{ expandTrigger: 'hover', label: 'name',value:'departmentId' }"></el-cascader>
              <el-date-picker  v-model="selectTime" type="daterange" :picker-options="pickerOptions"
                        range-separator="至"  start-placeholder="开始日期"  end-placeholder="结束日期"
                        align="right" style="width:390px"></el-date-picker>
            </div>
            <div class="report-op"><el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button></div>
            <div class="report-op"><el-button style="margin: 0" type="primary"  @click="print">打印</el-button></div>
            <div class="report-op"><i class="el-icon-download l-add-buttion" @click="exportExcel"></i></div>
        </div>
        <el-table id="printTable" :data="tableData" border style="width: 100%"  height="620" :span-method="arraySpanMethod" v-loading="listLoading">
          <el-table-column prop="staff_no" label="工号" width="100"></el-table-column>
          <el-table-column prop="staff_name" label="员工名称" width="100"></el-table-column>
          <el-table-column prop="production_name" label="产品名称" width="180"></el-table-column>
          <el-table-column prop="spec_name" label="规格(工艺)" width="200">
            <template slot-scope="scope">
              {{ scope.row.technology_name}}({{ scope.row.spec_name}})
            </template>
          </el-table-column>
          <el-table-column v-for="(item, i) in tableHead" :prop="item.prop" :label="item.name" :key="i" min-width="120">
            <template slot-scope="scope">
              {{ showdata(scope.row, item)}}
<!--              {{item.prop}}-->
            </template>
          </el-table-column>
<!--          <el-table-column prop="calc_kg" label="计价重量(kg)" width="120"></el-table-column>-->
<!--          <el-table-column prop="dispatch_kg" label="发料(kg)" width="90"></el-table-column>-->
<!--          <el-table-column prop="delivery_kg" label="交料(kg)" width="90"></el-table-column>-->
<!--          <el-table-column prop="total_price" label="总价(元)" width="100"></el-table-column>-->
        </el-table>
    </div>
</template>

<script>
    import { getRecordListV1 } from '../../api/record'
    import {tableDataToExcelV1, dataprint} from '../../util/util'
    import { getEquipmentListAll } from '../../api/equipment'
    import { getDepartmentList } from '../../api/department'
    import localCache from "../../util/localCache";
    export default {
        name: "recordReport",
        data(){
            return {
                listLoading: false,
                tableHead: [],
                tableData: [],
                reportColumn: {
                  'total_price': '工资',
                  'calc_kg': '计价重量',
                  'delivery_kg': '交料重量'
                },
                selectColumn: 'calc_kg',
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                selectTime: '',
                keyword: '',
                exportColumn: {

                },
                exportColumn0: {
                  'staff_no': {
                    title: '员工编号',
                    rowspan: 'span'
                  },
                  'staff_name': {
                    title: '员工名称',
                    rowspan: 'span'
                  },
                  'production_name':'产品名称',
                  'technology_name': {
                    title: '规格(工艺)',
                    formats:['technology_name', 'spec_name'],
                    format: 'technology_name(spec_name)'
                  },
                },
                subEquipments: [],
                subEquipmentId:'',
                searchDepart:'',
                treeData: [],
                priceType:''
            }
        },
        mounted(){
            let now = new Date()
            let end = new Date(now.getFullYear(),now.getMonth(),now.getDate(),0,0).getTime();
            let begin = end - 86400000 * (now.getDate()-1);
            let start = new Date(begin)
            this.selectTime = [start,now]

            this.refreshHead(begin, end)
            this.getRecordList_()
            this.getTree()
        },
        methods: {
          print(){
            var printHTML = document.getElementById('printTable').innerHTML; // 获取要打印的内容
            dataprint(printHTML)
          },
            refreshHead(begin, end) {
              this.tableHead = []
              this.exportColumn = JSON.parse(JSON.stringify(this.exportColumn0))
              for (let i = begin; i <= end; i+= 86400000) {
                let date = new Date(i);
                let day = date.getDate();
                let o = {
                  prop: `m${date.getMonth()+1}d${day}`,
                  name: `${day}日`,
                  day: day,
                  month: date.getMonth()
                }
                this.tableHead.push(o)
                this.exportColumn[o.prop] = {
                  title: o.name,
                  childs: {
                    [this.selectColumn]: this.reportColumn[this.selectColumn]
                  }
                }
              }

            },
            exportExcel(){
                tableDataToExcelV1(this.tableData,'员工生产记录统计',this.exportColumn)
            },
            search(){
                this.getRecordList_()
            },
            getRecordList_(){
                console.log(this.selectTime)
                if(!this.selectTime){
                    this.$message.error('请选择开始结束时间')
                    return
                }
                this.listLoading = true
                let departmentId = ''
                if(this.searchDepart){
                    departmentId = this.searchDepart[this.searchDepart.length-1]
                }
                let param = {
                  customerId: localCache.getCurrentCustomerId(),
                  beginTime: parseInt(this.selectTime[0].getTime()/1000),
                  endTime: parseInt(this.selectTime[1].getTime()/1000),
                  keyword: this.keyword,
                  departmentId:departmentId
                }
                if(param.beginTime == param.endTime){
                  param.endTime += 86400
                }
                getRecordListV1(param).then(res => {
                    this.listLoading = false
                    if (res.errorcode !== 0) {
                        this.$message.error(res.message)
                    } else {
                        this.refreshHead(this.selectTime[0].getTime(), this.selectTime[1].getTime())
                        this.tableData = this.parseData(res.data)
                    }
                }).catch(() => {
                    this.listLoading = false
                })
            },
            arraySpanMethod({ row, column, rowIndex, columnIndex }){
              if(columnIndex == 0 || columnIndex == 1){
                if(row.span){
                  return row.span
                }
              }
            },
            parseData(data){
              let t
              let d = []
              let o = {}
              let staff = {}
              for (let i = 0,len = data.length; i < len; i++) {
                t = data[i]
                let key = t.staff_no+t.production_id+t.technology_id+t.spec_id
                if(!o[key]){
                  o[key] = {
                    staff_no: t.staff_no,
                    production_id: t.production_id,
                    technology_id: t.technology_id,
                    spec_id: t.spec_id,
                    production_name: t.production_name,
                    spec_name: t.spec_name,
                    staff_name: t.staff_name,
                    technology_name: t.technology_name
                  }
                  d.push(o[key])


                  if(!staff[t.staff_no]){
                    staff[t.staff_no] = o[key]
                  }else{
                    if(!staff[t.staff_no].span){
                      staff[t.staff_no].span = {
                        rowspan: 2,
                        colspan: 1
                      }
                    }else{
                      staff[t.staff_no].span.rowspan ++
                    }
                    o[key].span = {
                      rowspan: 0,
                      colspan: 0
                    }
                  }
                }
                o[key][`m${t.month}d${t.day}`] = {
                  delivery_kg: t.delivery_kg,
                  calc_kg: t.calc_kg,
                  total_price: t.total_price,
                }
              }
              return d
            },
            showdata(row, item){
              let o = row[item.prop]
              if(o){
                return o[this.selectColumn]
              }
              return ''
            },
            getTree() {
                getDepartmentList({
                    customerId:localCache.getCurrentCustomerId()
                }).then(res => {
                    if (res.errorcode !== 0) {
                        this.$message.error(res.message)
                    } else {
                        this.treeData = res.data
                    }
                }).catch(() => {
                })
            },
        }
    }
</script>

<style lang="scss">
    .record-report-container{
        .t-top-bar{
            display: flex;
        }
        .report-op{
            margin-right: 15px;
        }
        .report-op:last-child{
            margin-left: auto;
        }
        .search-input{
            width: 250px;
            margin-right: 15px;
        }
        .search-input200{
            width: 200px;
            margin-right: 15px;
        }
        .el-table td{
            padding: 0;
        }
    }

</style>
